import Crew from "../crew/Crew";
import CharacterSave from "./CharacterSave";

export default class CrewSave {
    constructor() {        
    }

    /**
     * @param {Crew} crew
     * @returns {Object}
     */
    static generateSave(crew) {
        const saveState = {};

        saveState.miners = [];
        for (let i = 0; i < crew.miners.length; i++) {
            saveState.miners.push(CharacterSave.generateSave(crew.miners[i]));
        }

        return saveState;
    }

    /**
     * @param {Crew} crew
     * @param {Object} saveState 
     */
    static loadSave(crew, saveState) {
        if (!saveState) {
            console.log('CrewSave.loadSave() No save state. Not loading crew!');
            return;
        }

        const minerStates = saveState.miners;
        if (!minerStates || minerStates.length === 0) {
            console.log('CrewSave.loadSave() No miners data found');
            return;
        }

        // Create and Load the main miner.
        console.log('CrewSave.loadSave() create main miner');
        const mainMiner = crew.createMainMiner();
        CharacterSave.loadSave(mainMiner, minerStates[0]);

        // Load the rest of the crew. Start at 1
        for (let i = 1; i < minerStates.length; i++) { 
            const character = crew.addNewMinerForSaveLoad(); // Creates miner, adds to crew, returns it.
            CharacterSave.loadSave(character, minerStates[i]);
        }
    }
}